<template>
    <!-- Banner de incio -->
    <div class="bannerHome">
        <div class="row">
            <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <p>Jun 16, 2024</p>
                <h1>
                    Carrera de Obstáculos
                </h1>
            </div>
            <div class="colImg col-lg-6 col-md-12 col-sm-12 col-xs-12 text-center mt-4">
                <img src="https://firebasestorage.googleapis.com/v0/b/el-terreno-e5b55.appspot.com/o/Carrera_obstaculos%2FJiloMagico.jpg?alt=media&token=2e2974b6-06ff-45e5-aa9f-6a6de2ef777a"
                    alt="Logo Banner" class="imgHome2 img-fluid" />
            </div>
        </div>
    </div>

    <!-- Contenido de la pagina principal -->
    <main class="container mt-3 text-center">
        <div class="container">
            <div class="row">
                <div class="col-lg-5 mol-md-12 col-sm-12 col-xs-12">
                    <div class="card cardInfo shadow rounded-2" id="registro">
                        <img class="logoCard img-fluid"
                            src="https://firebasestorage.googleapis.com/v0/b/el-terreno-e5b55.appspot.com/o/Carrera_obstaculos%2FLogoCarrera2.jpg?alt=media&token=cae77b5a-3123-4a44-96d9-f50e43617ba6"
                            alt="Logo" />
                        <div class="card-body">
                            <h4 class="card-title">Carrera de Obstáculos</h4>
                            <h5 class="card-subtitle mb-3">Canalejas - México</h5>

                            <ul class="list-group">
                                <li class="list-group-item">
                                    <strong>Fecha:</strong> Domingo, 16 de junio
                                </li>
                                <li class="list-group-item">
                                    <strong>Lugar:</strong> Cancha de Fut 7 aun lado del Cecytem - Canalejas
                                </li>
                                <li class="list-group-item">
                                    <strong>Hora de Inicio:</strong> 8:00 AM
                                </li>
                                <li class="list-group-item">
                                    <strong>Distancias:</strong> 6, 10 y 15 km
                                </li>
                            </ul>

                            <a href="#" class="btn btn-primary btnInscripcion mt-3">
                                Inscripción finalizada
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-7 col-md-12 col-sm-12 col-xs-12 mt-5">
                    <img class="imgBanner img-fluid"
                        src="@/assets/images/logo_principal.png"
                        alt="Logo" />

                    <h2 class="mt-2">¡Únete a nuestra carrera de obstaculos!</h2>
                    <p>
                        "Únete a nosotros para la emocionante carrera que seguirá al entrenamiento especial
                        el <b>16 de junio de 2024</b>. ¡Todos son
                        bienvenidos a participar en este desafío lleno de adrenalina! Mejora tus habilidades,
                        desafía tus límites y prepárate para una experiencia única. ¡Te esperamos en la línea
                        de salida!"
                    </p>
                </div>
            </div>

            <!-- Primer apartado -->
            <br>
            <div class="sp1 mt-3 text-center" id="informacion">
                <h1>6, 10 y 15km con Obstaculos</h1>

                <div class="row">
                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 cols">
                        <div class="card mx-auto shadow" style="max-width: 400px">
                            <div class="card-body">
                                <div class="text-center mb-4">
                                    <i class="fas fa-person-running fa-4x text-primary"></i>
                                </div>
                                <h3 class="card-title text-center">
                                    Tipos de Obstáculos
                                </h3>
                                <h6 class="card-subtitle text-center text-muted mb-4">
                                    Nivel: Intermedio
                                </h6>
                                <ul class="list-unstyled">
                                    <li class="mb-2">
                                        <i class="fas fa-check fa-2x text-success"></i>Arrastre Tipo Militar
                                    </li>
                                    <li class="mb-2">
                                        <i class="fas fa-check fa-2x text-success"></i>Muro
                                    </li>
                                    <li class="mb-2">
                                        <i class="fas fa-check fa-2x text-success"></i>Pasa Manos
                                    </li>
                                    <li class="mb-2">
                                        <i class="fas fa-check fa-2x text-success"></i>Subir Soga
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 cols">
                        <div class="card mx-auto shadow" style="max-width: 400px">
                            <div class="card-body">
                                <div class="text-center mb-4">
                                    <i class="fas fa-location-dot fa-4x text-primary"></i>
                                </div>
                                <h3 class="card-title text-center mb-3">Salida y Meta:</h3>
                                <h4 class="card-subtitle text-center mb-4">
                                    Cancha de Futbol 7 entre Modulo de Policia y Cecytem Plantel Jilotepec.
                                </h4>
                                <p class="card-text text-center mb-0">
                                    Búscalo en Google Maps como:<br />
                                    <b>CECyTEM Palntel Jilotepec</b>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="sp3 text-center">
                <br>
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cols">
                        <div class="card mx-auto shadow">
                            <div class="card-header bg-primary text-white headerCard">
                                Categorías de la Carrera
                            </div>
                            <div class="card-body text-center">
                                <ul class="list-unstyled text-left d-inline-block mt-3">
                                    <li class="mb-3">
                                        <!--<i class="fas fa-child fa-2x text-success"></i>-->
                                        <b class="cat">Infantil:</b> 6 a 10 años (Carrera de 3km)
                                    </li>
                                    <li class="mb-3">
                                        <!--<i class="fas fa-child-reaching fa-2x text-success"></i>-->
                                        <b class="cat">Juvenil:</b> 12 a 15 años (Carrera de 6km)
                                    </li>
                                    <li class="mb-3">
                                        <!--<i class="fas fa-person fa-2x text-success"></i>-->
                                        <b class="cat">Master:</b> 40 años en adelante (Carrera de 10km)
                                    </li>
                                    <li class="mb-3">
                                        <!--<i class="fas fa-check fa-2x text-success"></i>-->
                                        <b class="cat">Libre:</b> Competencia por premiación en 15km
                                    </li>
                                </ul>

                                <h4>Monto a repartir: <b class="cat">$4000</b></h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="sp4 text-center">
                <br>
                <div class="row">
                    <h1>Kits de la Carrera</h1>

                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cols">
                        <img src="https://firebasestorage.googleapis.com/v0/b/el-terreno-e5b55.appspot.com/o/Carrera_obstaculos%2FPlayera.jpeg?alt=media&token=505bc8b1-d996-4da4-9dae-5fd9db26a0d8"
                            class="img-fluid rounded-2 mx-auto" width="640" height="640">
                        <div class="card mx-auto shadow mt-2">
                            <div class="card-body">

                                <div class="text-center mb-3">
                                    <i class="fas fa-person-running fa-4x text-primary"></i>
                                </div>

                                <h3 class="card-title text-center mb-3">
                                    Entrega de Kits
                                </h3>

                                <p class="card-text text-center">
                                    Viernes 14 de junio y Sabado 15 en el <b>Gimnasio El Terreno</b>. En un horario de
                                    10:00 AM a 3:00 PM.
                                </p>
                                <p class="card-text text-center">
                                    Domingo 16 de junio en el <b>Gimnasio El Terreno</b>. En un horario de 6:00 AM a
                                    7:00 AM.
                                    En el incio de la Competencia (Pasando las 7 AM no se entregaran mas Kits).
                                </p>

                                <p class="card-text text-center">
                                    <b>
                                        Presentarse con Identificacion Oficial.
                                        <br>Menores de edad llevar responsiva firmada por algun tutor.
                                    </b>
                                </p>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <br>
            <div class="sp2 mt-3 text-center">
                <h1>Costos y Formas de Pago</h1>

                <div class="row">
                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 cols">
                        <div class="card mx-auto shadow" style="max-width: 400px">
                            <div class="card-body">
                                <h5 class="card-title text-center mb-4"> Precios de Inscripción </h5>
                                <ul class="list-group list-group-flush">
                                    <li class="list-group-item d-flex justify-content-between align-items-center">
                                        <b>Etapa 1:</b><span> Del 25 de marzo al 1 de abril:</span>
                                        <span><b></b></span>
                                    </li>
                                    <li class="list-group-item d-flex justify-content-between align-items-center">
                                        <b>Etapa 2:</b><span> Del 2 de abril al 2 de mayo:</span>
                                        <span><b></b></span>
                                    </li>
                                    <li class="list-group-item d-flex justify-content-between align-items-center">
                                        <b>Etapa 3:</b><span> Del 2 de mayo al 2 de junio:</span>
                                        <span><b>$400</b></span>
                                    </li>
                                    <li class="list-group-item d-flex justify-content-between align-items-center">
                                        <b>Etapa 4:</b><span> Del 2 de junio al 13 de junio:</span>
                                        <span><b>$450</b></span>
                                    </li>
                                    <li class="list-group-item d-flex justify-content-between align-items-center">
                                        <b>Etapa 5:</b><span> Del 13 de junio al 16 de junio:</span>
                                        <span><b>$500</b></span>
                                    </li>
                                </ul>

                                <br>
                                <h6>Cupo limitado aparta tu lugar lo antes posible.</h6>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 cols">
                        <div class="card mx-auto shadow" style="max-width: 400px">
                            <div class="card-body">
                                <h5 class="card-title text-center mb-4">Formas de Pago</h5>
                                <ul class="list-group list-group-flush">
                                    <li class="list-group-item">
                                        <p class="mb-1">Transferencia electrónica o depósito:</p>
                                        <b>BBVA: 012180015670641909 o al 4152314110754507</b>
                                        <p class="mb-0">Titular: Carrera de Obstáculos Canalejas</p>
                                        <p class="mb-0">Motivo: Pago de carrera</p>
                                    </li>
                                    <li class="list-group-item">
                                        <p class="mb-1">Transferencia electrónica:</p>
                                        <b>OXXO: 646420146403035509</b> Stp
                                    </li>
                                    <li class="list-group-item">
                                        <p class="mb-1">Depósito a cuenta SPIN:</p>
                                        <b>OXXO: 2242170420122648</b> Spin
                                    </li>
                                    <li class="list-group-item">
                                        <p class="mb-1">Envía tu comprobante de pago al:</p>
                                        <strong>5540861907</strong>
                                        <p class="mb-0">
                                            Incluye tu Nombre Completo, Número de Teléfono, la
                                            Distancia Elegida y Listo.
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="row mt-2">
                    <h1>¡Promoción de Grupo!</h1>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cols">
                        <div class="card mx-auto shadow card-promocion" style="max-width: 600px">
                            <div class="card-body">
                                <p class="card-text">Registra más de <b>10 competidores</b> y todos pagan únicamente
                                    <b>$370</b> pesos.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mt-3">
                    <h1>¡Promoción!</h1>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cols">
                        <div class="card mx-auto shadow card-promocion" style="max-width: 600px">
                            <div class="card-body">
                                <p class="card-text">
                                    Comparte cualquier <b>Flayer</b> de la carrera en todas tus <b>redes</b>.
                                    <br>
                                    Y envíanos una captura de pantalla y obtendrás un descuento para pagar solo: <br>
                                    <b>$370</b>.
                                    <br>
                                    ¡No la dejes pasar!.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <br>
            <div class="alert alert-light text-center mx-auto shadow" role="alert" style="max-width: 400px">
                ¿Dudas y preguntas? Llámanos al <b>5540861907</b>
            </div>

        </div>
    </main>
</template>

<script setup>
import '@fortawesome/fontawesome-free/css/all.css'
import { onMounted, onUnmounted } from 'vue'

onMounted(() => {
  document.body.style.backgroundColor = '#F6F6F6'
})

onUnmounted(() => {
  document.body.style.backgroundColor = '#F6F1EC'
})
</script>

<style scoped>
@font-face {
    font-family: "FuentePersonalizada";
    src: url('../assets/fonts/GreenKingsWood-Regular1.otf') format('opentype');
}

@font-face {
    font-family: 'FuerntePerso2';
    src: url('../assets/fonts/Roboto-Regular.ttf') format('opentype');
}

#navModified {
    background: #1E7BC1;
}

#navModified .nav-link {
    font-family: 'FuentePersonalizada', Arial sans-serif;
    font-size: 25px;
}

.bannerHome {
    background-color: #303030;
    padding: 16px;
}

.bannerHome p {
    color: #fff;
    font-size: 23px;
    margin: 0 0 0 0;
}

.bannerHome h1 {
    font-family: 'FuentePersonalizada', Arial sans-serif;
    font-size: 5rem;
    color: #fff;
}

.bannerHome img {
    margin: 0 auto;
    width: 190px;
    height: 190px;
}

.bannerHome .imgHome1,
.bannerHome .imgHome2 {
    border-radius: 120px;
}

.cardInfo {
    padding: 10px;
}

.cardInfo .logoCard {
    border: 1px solid #8d8d8d;
    border-radius: 120px;
    box-shadow: 0 1px 2px #ccc;
    height: 230px;
    width: 230px;
    margin: 0 auto;
}

.imgBanner {
    margin: 0 auto;
    width: 230px;
    height: 230px;
}

.btnInscripcion {
    width: 100%;
    border-radius: 15px;
}

.sp1 .row .cols {
    padding: 10px;
}

.sp1 h1 {
    font-family: 'FuentePersonalizada', Arial sans-serif;
    font-size: 60px;
}

.sp1 .card {
    height: 360px;
}

.sp1 .card-header {
    font-family: 'FuentePersonalizada', Arial sans-serif;
    font-size: 30px;
}

.sp3 {
    font-size: 18px;
}

.sp3 .headerCard {
    font-family: 'FuentePersonalizada', Arial sans-serif;
    font-size: 30px;
}

.cat {
    color: green;
}

.sp4 h1 {
    font-family: 'FuentePersonalizada', Arial sans-serif;
    font-size: 60px;
}

.sp2 .row .cols {
    padding: 10px;
}

.sp2 h1 {
    font-family: 'FuentePersonalizada', Arial sans-serif;
    font-size: 60px;
}

.sp2 .card {
    font-size: 17px;
}

.sp2 .card b {
    color: green;
}

.sp2 .card-promocion {
    font-size: 23px;
}

.alert {
    width: 70%;
    background-color: #ff464c;
    color: #fff;
}
</style>
